import React, { useState, useEffect } from "react";
import { useLocation, useNavigate  } from "react-router-dom";
import { Modal } from "react-bootstrap"; 
import Countdown, {zeroPad } from 'react-countdown';
import QRCode from "react-qr-code";

function MakePayment({ userData, hasEWallet }) {

    const [accountNumber, setAccountNumber] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const [, setIsLoading] = useState(false); 
    const [showModal, setShowModal] = useState(false);
    const [arrivalTime, setArrivalTime] = useState(10); 
    const [modalMessage, setModalMessage] = useState("");
    const token = localStorage.getItem('token');
    const navigate = useNavigate(); 
    const location = useLocation(); 
	const { amount, payment_icon, payment_type, paymentMethodName, promotion } = location.state || {}; 
	const [paymentSystems, setPaymentSystem] = useState([]);

	const [transaction, setTransaction] = useState('');

	const [showType, setShowType] = useState('');
	const [isUSDT, setIsUSDT] = useState(false);

	useEffect(() => { 
		if (payment_type === 'Personal') {
			setShowType('Send Money');
		} else if (payment_type === 'Agent') {
			setShowType('Cash Out');
		} else if (payment_type === 'Merchant' || payment_type === 'Marchent') {
			setShowType('Make Payment');
		}
		if (payment_type === 'USDT') {
			setIsUSDT(true);
			setArrivalTime(30);
		} else {
			setIsUSDT(false);
			setArrivalTime(10);
		}
		if (!payment_type) {
			navigate('/deposit');
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (hasEWallet) {
			if (location?.state?.transaction) {
				setTransaction(location?.state?.transaction);
			}
			if (location?.state?.number) {
				setPaymentSystem({
					account_number: location?.state?.number,
					id: location?.state?.number,
				});
			}
			if (location?.state?.timer) {
				setArrivalTime(location?.state?.timer);
			}
			if (location?.state?.message) {
				if (location?.state?.message?.length > 0) {
					setModalMessage(location?.state?.message);
					setShowModal(true);
				}
			}
		}
		// prevent back with alert yes no
		// window.onbeforeunload = function () {
		// 	return "Are you sure you want to leave? Your payment may not be completed.";
		// }
		// return () => {
		// 	window.onbeforeunload = null; // Clean up the event listener
		// }
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasEWallet, location?.state]);
	
	
	const [numbers, setNumbers] = useState([]);
	const fetchOther = async () => {
		const token = localStorage.getItem('token');
		if (token) {
			try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
					method: 'GET',
					headers: {
						'Authorization': `Bearer ${token}`,
					},
				});

				if (response.ok) {
					const data = await response.json();
					let numbers = [];
					if (userData?.session_id === '1') {
						numbers.push(userData?.phone);
					}
					if(data?.data && data?.data?.length > 0) {
						data.data.forEach((item) => {
							if (item.isverify) {
								numbers.push(item.contract_value);
							}
						});
					}
					setNumbers(numbers);
					if(numbers?.length > 0) {
						setAccountNumber(numbers[0]);
					}
				} else {
					console.error('Failed to fetch user data');
				}
			} catch (error) {
				console.error('Error fetching user data:', error);
			}
		}
	};
	
	useEffect(() => {
		fetchOther();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userData?.name]);

	
	useEffect(() => {
		if (paymentMethodName) {
			if (!hasEWallet) {
				const fetchPaymentMethodDetails = async () => {
					try {
						const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-wallet-number?name=${paymentMethodName}&account_type=${payment_type}&amount=${amount}`, {
							headers: {
								Authorization: `Bearer ${token}`,
								'Origin': window.location.origin,
							},
						});
						const data = await response.json();

						if (data) {
							setPaymentSystem(data[0]);
						}
					} catch (error) {
						console.error("Error fetching payment method details:", error);
					} finally {
						setIsLoading(false);
					}
				};

				fetchPaymentMethodDetails();
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [paymentMethodName, token]);
	
	// useEffect(() => {
	// 	let min = arrivalTime;
	// 	const countdown = setInterval(() => {
	// 			min--;
	// 		   setArrivalTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
	// 		   timeCount();
	// 		   let dMin = min < 10 ? `0${min}` : min; // 2 digit number
	// 		   document.querySelector('.min').innerHTML = dMin;
	// 		}, 60000);
	// 	 timeCount();
	// 	 return () => { clearInterval(countdown); clearInterval(countdownSec);};
    //    }, []);

    const handleSubmit = async () => {
        // Validate each field with specific error messages
        if (!accountNumber || accountNumber?.length !== 11 || !/^\d{11}$/.test(accountNumber)) {
          setModalMessage("অনুগ্রহ করে একটি সঠিক ১১-সংখ্যার অ্যাকাউন্ট নম্বর দিন।");
          setShowModal(true);
          return;
        }
        
        if (!transactionId || transactionId?.length < 7) {
          setModalMessage("অনুগ্রহ করে আপনার TRX ID প্রদান করুন। এটি বৈধ হতে হবে।");
          setShowModal(true);
          return;
        }
      
        setSubmitLoading(true);
        const remoteId = localStorage.getItem("remote_id");
      
        
		let requestBody = {};
		let apiUrl = '';
		if (hasEWallet) {
			apiUrl = `${process.env.REACT_APP_API_URL}/api/ewa/confirm`;
			requestBody = {
				trx_id: transaction,
				trxid: transactionId,
				number: accountNumber
			};
		} else {
			apiUrl = `${process.env.REACT_APP_API_URL}/api/submit-deposit`;
			requestBody = {
				remote_id: remoteId,
				account_number: accountNumber,
				transaction_id: transactionId,
				amount: amount,
				payment_id: paymentSystems.id,
				promotion_id: promotion, 
			};
		}
      
		try {			

          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            setModalMessage("Submission failed: " + errorData.message);
            setShowModal(true);
            return;
          }
      
          const data = await response.json();
      
          if (data) {
            setModalMessage("জমা দেওয়া সফল হয়েছে!");
      
            navigate("/payment-request", {
              state: {
                amount: amount,
                payment_icon: payment_icon,
              },
            });
          } else {
            setModalMessage(data.message);
            setShowModal(true); // Show modal with the error message
          }
        } catch (error) {
          setModalMessage("একটি ত্রুটি ঘটেছে। দয়া করে আবার চেষ্টা করুন।");
          setShowModal(true); // Show modal on error
        } finally {
          setSubmitLoading(false);
        }
    };
      
    return(
      <div className="third-party-box third-party-mort-cont">
      <div className="third-party-title">
        <img alt={paymentMethodName || 'Payment method'} src={payment_icon? `${process.env.REACT_APP_API_URL}/storage/${payment_icon}` : `${process.env.REACT_APP_API_URL}/default-icon.png`} />
        <h3>{paymentMethodName} {payment_type}</h3>
      </div>
      <div className="third-party-bar">
					</div>
					
				{ !isUSDT && (
				<div className="third-party-main">
						<div className="tips-group">
							<div id="minSec">
								<Countdown date={Date.now() + (1000 * 60 * arrivalTime)} intervalDelay={0} precision={2} renderer={props => <div>{zeroPad(props.minutes)}:{zeroPad(props.seconds)}</div>}></Countdown>
							</div>
						<ul>
							<li>আপনি যে টাকা পাঠাবেন, এবং আমরা যে টাকা পাব—দুটিই সমান হতে হবে। ভুল পরিমাণ বা তথ্য দিলে ডিপজিট না পেলে আমরা কোনো দায় নেব না।</li>
							<li> যেকোনো নম্বর ব্যবহার করুন — যেকোনো বৈধ ১১ সংখ্যার ফোন নম্বর থেকেই টাকা পাঠাতে পারবেন।</li>
						</ul>
						</div>
						<h2>
						অনুগ্রহ করে <strong>{showType}</strong> নীচের অ্যাকাউন্টে <Countdown date={Date.now() + (1000 * 60 * arrivalTime)} intervalDelay={0} precision={2} renderer={props => <span>{zeroPad(props.minutes)}:{zeroPad(props.seconds)}</span>}></Countdown><br />
						মিনিটের মধ্যে জমা ফর্ম পূরণ ও জমা দিন।
						</h2>
						<div className="third-party-content third-party-account-content">
							<img alt="Payment background" src={`./icons/payment-bg.png`} />
							<div className="pay-wrap">
								<div className="pay-inner">
								<div className="pay-block">
									<div className="text">
									<div className="pay-account">
										<h4>
									{paymentSystems?.account_number
									? `${paymentSystems.account_number.slice(0, 2)}x-xxx-xxx-${paymentSystems.account_number.slice(-2)}`
									: 'N/A'}
									</h4>

										<a href="#!" role="button" className="button-icon-copy" onClick={() => {
								const accountNumber = paymentSystems.account_number;
								if (accountNumber) {
								if(navigator?.clipboard){
									navigator.clipboard.writeText(accountNumber);
									alert(`Account number copied!`);
								}
									} else {
									alert("No account number to copy!");
									}
								}}>Copy </a>
							</div>
							<div className="pay-info">
								<p>
								Amount:
								<span>{amount}.00</span>
								</p>
								<a href="#!" role="button" className="button-icon-copy" onClick={() => {
								if (amount) {
									if (navigator.clipboard) {
										navigator.clipboard.writeText(amount.toString());
										alert(`Amount copied: ${amount}`);
									}
								} else {
								alert("No Amount to copy!");
								}
							}}>Copy </a>
							</div>
							<div className="qrcode" style={{display: 'none'}} id="qrCodeContainer" />
							</div>
							<div className="receipt-wrap">
							<form id="updateForm" name="updateForm" action noValidate="novalidate">
								<div className="receipt-inner">
								<div className="bank-acc-wrap">
									<h3>Phone Number</h3>
									<select type="text"  
									value={accountNumber}
									onChange={(e) =>
									setAccountNumber(e.target.value)
									} name="accountNumber"
									placeholder="Please input data" 
									aria-required="true" style={{ textTransform: 'uppercase' }}
									defaultValue={accountNumber} >
									<option value="">Select Phone Number</option>
									{numbers.map((number, index) => (
										<option key={index} value={number}>
										{number}
										</option>
									))}
									</select>
									
								</div>
								<div className="reference-wrap">
									<h3>Reference No. / Trans ID</h3>
									<input type="text"  
									value={transactionId} 
									onChange={(e) =>setTransactionId(e.target.value)}
									name="transactionId" placeholder="Please input data" 
									aria-required="true" style={{textTransform: 'uppercase'}} />
								</div>
								</div>
								<div className="upload-wrap">
								<div className="title">
									<h3>Upload receipt</h3>
									<button id="clearUploadImages">Reset Receipt</button>
								</div>
								<input id="uploadImages" name="uploadImages" type="file" accept="image/*" multiple />
								<div className="dropImages" id="dropImages">Drop file here</div>
								<img id="previewImage" style={{marginTop: '10px', maxWidth: '100%', maxHeight: '310px'}} draggable="false" src alt="" />
								</div>
							</form>
							</div>
						<button
							onClick={handleSubmit}
							id="confirm"
							className="submit-btn"
							disabled={submitLoading}
							>
							{submitLoading ? 'Submitting...' : 'Submit'}
							</button>
						</div>
						<div id="resultBlock" className="pay-panding">
							<div className="text">
							<h4>{paymentSystems.account_number}</h4>
							<p className="pay-info">পরিমাণ: <span>{amount}.00</span></p>
							</div>
							<div className="status-wrap">
							<p>
								ধন্যবাদ!<br />
								আমাদের টিম আপনার লেনদেন যাচাই করছে, দয়া করে অপেক্ষা করুন।
							</p>
							<br />
							<div className="status"><span>বিচারাধীন...</span></div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</div>
		)}
			{isUSDT && (
			<div className="third-party-bar" style={{lineHeight: '1.5'}}>
				<div className="tips-group">
					<div id="minSec">
						<Countdown date={Date.now() + (1000 * 60 * arrivalTime)} intervalDelay={0} precision={2} renderer={props => <div>{zeroPad(props.minutes)}:{zeroPad(props.seconds)}</div>}></Countdown>
					</div>
					<ul>
						<li>আপনি যে টাকা পাঠাবেন, এবং আমরা যে টাকা পাব—দুটিই সমান হতে হবে। ভুল পরিমাণ বা তথ্য দিলে ডিপজিট না পেলে আমরা কোনো দায় নেব না।</li>
					</ul>
						<p className="text-center">
							<strong>
								USDT TRX20 ওয়ালেট ঠিকানা: <br />
								<input type="text" className="pinp" readOnly value={paymentSystems.account_number ? paymentSystems.account_number : 'N/A'} />
							</strong>
						<a href="#!" role="button" className="button-icon-copy" onClick={() => {
							const usdtAccount = paymentSystems.account_number;
							if (usdtAccount) {
								if(navigator?.clipboard){
									navigator.clipboard.writeText(usdtAccount);
										alert(`Account number copied!`);
									}
								} else {
									alert("No account number to copy!");
								}
							}}>Copy </a>
						</p>
						</div>
						<div className="pay-wrap">
						<div style={{ height: "auto", margin: "0 auto", maxWidth: "180px", width: "180px" }}>
							<QRCode
								size={512}
								style={{ height: "auto", maxWidth: "100%", width: "100%" }}
								value={paymentSystems.account_number}
								viewBox={`0 0 512 512`}
							/>
						</div>

						<form id="updateForm" name="updateForm" action noValidate="novalidate">
							<div className="receipt-inner">
								<div className="reference-wrap">
									<h3>Trans ID / Note</h3>
									<input type="text" className="pinp"
									value={transactionId} 
									onChange={(e) =>setTransactionId(e.target.value)}
									name="transactionId" placeholder="Please input data" 
									aria-required="true" />
								</div>
							</div>
							<div className="upload-wrap">
								<div className="title">
									<h3>Upload receipt</h3>
								</div>
								<input id="uploadImages" name="uploadImages" type="file" accept="image/*" multiple />
								<div className="dropImages" id="dropImages">Drop file here</div>
								<img id="previewImage" style={{marginTop: '10px', maxWidth: '100%', maxHeight: '310px'}} draggable="false" src alt="" />
							</div>
						</form>

						<button
							onClick={handleSubmit}
							id="confirm"
							className="submit-btn"
							disabled={submitLoading} >
							{submitLoading ? 'Submitting...' : 'Submit'}
						</button>

				</div>
			</div>
		)}
			
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Message</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>{modalMessage}</p>
                            </Modal.Body>
                        </Modal>
    </div>
    
    );
}
export default MakePayment;